// @flow

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import EmptyState from 'components/competitionsInternationales/CompetitionsinternationalesSingleMatchEmptyState';
import CardPlayer from 'containers/fragments/card/CardPlayerContainer';
import { STATUS_SUCCESS } from 'constants/statusConstants';
import { withHelmet } from 'infrastructure/seo/Helmet';
import type { Status } from 'types/Status';
import type { CompetitionInternationale } from 'types/competitionsInternationales';
import { dynamicClassName } from 'utils/dynamicClassName';

export type StateProps = {
  data: CompetitionInternationale,
  status: Status
};

type Props = {
  match: any,
  history: any,
  location: any
} & StateProps;

class CompetitionsInternationalesGroup extends Component<Props> {
  renderPlayersByPoste = (players: Array<Object>) => {
    const restCards = players.length % 3;
    const { data } = this.props;
    return players.map((player, index) => {
      const slug = player.url_relative.split('/').pop();
      const isOnLastLine =
        (restCards === 0 && index >= players.length - 3) || (restCards !== 0 && index >= players.length - restCards);

      const classNameContainer = dynamicClassName('col col-md-6 col-lg-4 mb-1 mb-md-3');
      isOnLastLine ? classNameContainer.add('mb-lg-0') : classNameContainer.add('mb-lg-4');

      let poste = '';
      if (player.poste) {
        poste = player.poste.name;
      } else if (player.poste_staff) {
        poste = player.poste_staff.map(({ name }) => name).join(', ');
      }

      return (
        <div key={index} className={classNameContainer.build()}>
          <CardPlayer
            url={`/competitions-internationales/${data.slug}/le-groupe/${slug}`}
            title={player.title}
            poste={poste}
            featured_media={{ src: player.image_thumbnail }}
            noTextOverflow
          />
        </div>
      );
    });
  };

  render() {
    const { data } = this.props;

    if (!data) {
      return null;
    }

    let soustitre = '';
    if (data.meta.group_page_title_two) {
      soustitre = data.meta.group_page_title_two;
    } else if (data.title.raw) {
      if (data.title.raw.match(/Coupe /) || data.title.raw.match(/coupe /)) {
        soustitre = 'pour la ' + data.title.raw;
      } else if (data.title.raw.match(/Tournoi /) || data.title.raw.match(/tournoi /)) {
        soustitre = 'pour le ' + data.title.raw;
      } else {
        soustitre = 'pour les ' + data.title.raw;
      }
    }

    const isEmpty = Object.values(data.group_composition).every((item: any) => !item.length);
    let classes = 'group';
    if (isEmpty) {
      classes = `${classes} with-empty-state`;
    }

    return (
      <>
        <section className={classes}>
          <h2>
            {
              data.meta.group_page_title_one || 'La Composition de l\'Équipe de France'
            }
             <br />
            <span>{soustitre}</span>
          </h2>

          {isEmpty ? (
            <EmptyState
              titleFirstPart="Composition"
              titleSecondPart="du groupe"
              description="La composition du groupe sera disponible très prochainement."
              backgroundImage="/img/empty-state-composition.png"
            />
          ) : (
            <ul className="posts-list">
              {Object.keys(data.group_composition).map((poste, index) => {
                if (!data.group_composition[poste].length) {
                  return null;
                }

                return (
                  <div key={'poste_' + index} className="row mb-4">
                    <div className="players-list">
                      <div className="col col-lg-8on9">
                        <h3 className="mb-3">{poste}</h3>
                      </div>

                      <div className="row">
                        <div className="col col-lg-8on9">
                          {this.renderPlayersByPoste(data.group_composition[poste])}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </ul>
          )}
        </section>
        {!!data &&
          !!data.content_group_composition_page_bottom &&
          !!data.content_group_composition_page_bottom.data &&
          !!data.content_group_composition_page_bottom.data.length &&
          data.content_group_composition_page_bottom.data.map((bloc, index) => <ContentBloc key={index} {...bloc} />)}
      </>
    );
  }
}

export default withHelmet(withRouter(CompetitionsInternationalesGroup))((Helmet, pageProps: Props) => {
  const { data, status } = pageProps;

  if (status !== STATUS_SUCCESS || !data) {
    null;
  }

  let meta_title = `Équipe de France - Composition & Joueurs`;
  if (data.title.raw.match(/Coupe /) || data.title.raw.match(/coupe /)) {
    meta_title = `${meta_title} de la ${data.title.raw}`;
  } else if (data.title.raw.match(/Tournoi /) || data.title.raw.match(/tournoi /)) {
    meta_title = `${meta_title} du ${data.title.raw}`;
  } else {
    meta_title = `${meta_title} des ${data.title.raw}`;
  }
  meta_title = `${meta_title} - FFR`;

  return (
    <Helmet htmlAttributes={{ lang: 'fr' }}>
      {meta_title && <title>{meta_title}</title>}
      {meta_title && <meta property={'og:title'} content={meta_title} />}
    </Helmet>
  );
});
